import clsx from 'clsx';
import React from 'react';
import { sanitizers } from '@/utils/formValidation/sanitizers';

type PercentageFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: boolean;
  disabled?: boolean;
  className?: string;
};

export const PercentageField: React.FC<PercentageFieldProps> = ({
  value,
  onChange,
  placeholder = '0',
  error = false,
  disabled = false,
  className = '',
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = sanitizers.percentage(e.target.value);
    onChange(sanitized);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Prevent +, -, e, E keys (scientific notation and signs)
    if (e.key === '+' || e.key === '-' || e.key === 'e' || e.key === 'E') {
      e.preventDefault();
    }
  };

  return (
    <div
      className={clsx(
        'w-full px-3 py-2.5 bg-[#F4F4F4] rounded-[10px] flex items-center gap-2.5',
        error && 'outline outline-1 outline-[#CC4747] -outline-offset-1',
        className
      )}
    >
      <div className="text-black text-sm font-medium font-avenir">%</div>
      <input
        type="text"
        inputMode="numeric"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        disabled={disabled}
        className={clsx(
          'flex-1 min-w-0 bg-transparent border-none outline-none text-sm font-medium font-avenir',
          value ? 'text-black' : 'text-[#B2B2B2] placeholder:text-[#B2B2B2]'
        )}
      />
    </div>
  );
};
